<div class="row" *ngIf="showLayout">
  <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12"></div>
  <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 d-flex flex-row-reverse">
    <app-button
      [variant]="'primary'"
      [startIcon]="'fa-link'"
      [disabled]="disabled"
      [classes]="classes"
      (click)="onClick()"
    >
      {{ label || ('admin.store.setting.connect' | translate) }}
    </app-button>
  </div>
</div>

<app-button
  *ngIf="!showLayout"
  [variant]="'primary'"
  [startIcon]="'fa-link'"
  [disabled]="disabled"
  [classes]="classes"
  (click)="onClick()"
>
  {{ label || ('admin.store.setting.connect' | translate) }}
</app-button>
